import { render, staticRenderFns } from "./academy_teachers.vue?vue&type=template&id=4c4e2df8&scoped=true"
import script from "./academy_teachers.vue?vue&type=script&lang=js"
export * from "./academy_teachers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4e2df8",
  null
  
)

export default component.exports